/**
 * @fileoverview A conta da contratação na tela (31/10/2026, etapa 7 dos
 * planos): os itens e o total do mês, como o servidor calcula
 * (BillingServices/billingPricing.ts), para o resumo responder na hora. Quem
 * vale é o servidor; mude os dois juntos.
 */

import { i18n } from "../translate/i18n";

const summaryT = (key, options) => i18n.t(`billingOverview.${key}`, options);

export const money = (cents) => (Number(cents || 0) / 100).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export const thousands = (value) => Number(value || 0).toLocaleString("pt-BR");

/** Os itens da assinatura: o plano × licenças, o Chat Interno × licenças dele e o pacote de IA. */
export const contractItems = (catalog, { plan, seats, internalChatSeats, aiPackMessages }) => {
  const definition = catalog.plans.find((item) => item.key === plan);
  if (!definition) return [];
  const items = [];
  if (definition.pricePerUserCents > 0) {
    items.push({ code: "plan", quantity: Math.max(definition.minBilledUsers, seats || 0), unitCents: definition.pricePerUserCents, name: definition.name });
  }
  if (internalChatSeats > 0) items.push({ code: "internal_chat", quantity: internalChatSeats, unitCents: catalog.internalChatPriceCents });
  const pack = catalog.aiPacks.find((item) => item.messages === aiPackMessages);
  if (pack) items.push({ code: "ai_pack", quantity: 1, unitCents: pack.priceCents, messages: pack.messages });
  return items;
};

export const itemsTotal = (items) => items.reduce((sum, item) => sum + item.quantity * item.unitCents, 0);

/** "a, b e c": as partes do que está contratado numa frase. */
export const sentence = (parts) => (parts.length > 1 ? `${parts.slice(0, -1).join(", ")} ${summaryT("summary.and")} ${parts[parts.length - 1]}` : parts[0] || "");

/** Os planos pagos que o site oferece ("Criar conta grátis" do Basic ou do Pro), pelo nome. */
export const PAID_PLAN_NAMES = { basic: "Talk Basic", pro: "Talk Pro" };
export const isPaidPlan = (plan) => plan === "basic" || plan === "pro";

export const capitalize = (value) => (value ? value.charAt(0).toUpperCase() + value.slice(1) : value);

/** O que um contrato tem, numa frase ("Talk Basic com 3 licenças e 1 de Chat Interno"). */
export const describeTerms = (catalog, terms) => {
  const plan = catalog.plans.find((item) => item.key === terms.plan);
  if (terms.plan === "starter") return capitalize(summaryT("summary.starterInternal", { count: terms.internalChatSeats }));
  const parts = [summaryT("summary.seats", { count: terms.seats })];
  if (terms.internalChatSeats > 0) parts.push(summaryT("summary.internal", { count: terms.internalChatSeats }));
  if (terms.aiPackMessages) parts.push(summaryT("summary.pack", { messages: thousands(terms.aiPackMessages) }));
  return summaryT("pending.what", { plan: plan?.name, details: sentence(parts) });
};
